import { NAME_SPACE } from './config';
import NewsOverview from './NewsOverview.vue';

export default {
    name: NAME_SPACE,
    components: {
        'news-overview': NewsOverview,
    },
};
